module.exports = __webpack_public_path__ + "f620357d4e31ed85d6b2604e5cbd6fc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/night_38.jpg
// module id = 1778
// module chunks = 5